<template>
  <div>
    <LandingPageBody v-bind="landingPageProps" />
  </div>
</template>

<script>
import LandingPageBody from '@/components/CampaignLandingPage/LandingPageBody'
import { LandingPageType } from '@/enums/landing'
import { AUTH_ID } from '@/utils/store/getterTypes'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'UndershirtsReactivationLandingPage',
  layout: 'homepage-signup-button',
  components: {
    LandingPageBody
  },
  computed: {
    landingPageProps () {
      return {
        locizePath: 'LandingPage.UndershirtsReactivation',
        imagePath: '/images/frontend/reactivation/undershirts/',
        appCountry: this.country,
        locale: this.locale,
        userIdentifier: this.userId,
        landingpageUrl: '/undershirts/reactivate',
        primaryColor: '#EAE5DF',
        type: LandingPageType.reactivate
      }
    },
    ...mapState('app', {
      country: state => state.country,
      locale: state => state.locale
    }),
    ...mapGetters('auth', {
      userId: AUTH_ID
    })
  }
}
</script>

<style>

</style>
